import { AutomationHistoryWithAirport, RunScheduleAutomationInput, SearchTypeEnum } from '@/models/gen/graphql';

import { Dayts } from '@/utils';
import { RunScheduleAutomationDocument } from '@/api/queries';
import graphApi from '@/api';

const [, runScheduleAutomation] = graphApi(RunScheduleAutomationDocument);

const searchAutomationTrip = async (from: string, to: string, market: string[]): Promise<AutomationHistoryWithAirport> => {
  const fromDate = new Dayts(from).utc().startOf('day').add(3, 'hours');
  const toDate = new Dayts(to)
    .utc()
    .startOf('day')
    .add(1, 'day')
    .add(2, 'hours')
    .add(59, 'minutes')
    .add(59, 'seconds')
    .add(999, 'milliseconds');
  if (toDate.diff(fromDate, 'days') > 3) {
    toDate
      .setDate(fromDate)
      .add(3, 'days')
      .startOf('day')
      .add(1, 'day')
      .add(2, 'hours')
      .add(59, 'minutes')
      .add(59, 'seconds')
      .add(999, 'milliseconds');
  }
  if (!market.length) throw new Error('Market cannot be empty.');
  const input: RunScheduleAutomationInput = {
    query: [
      {
        airportCode: [
          {
            values: market,
            type: SearchTypeEnum.Or,
          },
        ],
        scheduled: [
          {
            values: [fromDate.toISOString(), toDate.toISOString()],
            type: SearchTypeEnum.Range,
          },
        ],
      },
    ],
  };

  const res = await runScheduleAutomation({ input });
  return res?.runScheduleAutomation?.automationHistory;
};

export default searchAutomationTrip;
